/**
 * 月租缴费
 *  */

export const MONTHLYLENHTHQUERY = "MONTHLYLENHTHQUERY"  // 包月时长列表

export const MERBERCARPUBLICQUERY = "MERBERCARPUBLICQUERY"  // 我的车辆列表
export const MONTHPAYADD = "MONTHPAYADD"   // 提交月租缴费订单
export const PARKINGPAYQUERY = "PARKINGPAYQUERY"   // 月租缴费-停车场列表
export const OEDERQUERY = "OEDERQUERY"   // 获取订单号
export const MONTHRENTTIME = "MONTHRENTTIME"   // 车辆对应停车场的月租期限
export const QUERYVEHICLES = "QUERYVEHICLES"



// WEBPACK FOOTER //
// ./src/store/month/types.js